import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../theme/ISpcTheme';

export type SimpleButtonClasses = 'button' | 'label' | 'outlined' | 'fullWidth';

const simpleButtonStyles = makeStyles<ISpcTheme, SimpleButtonClasses>(
  theme => ({
    button: {
      width: '300px',
      padding: 0,
      fontFamily: theme.typography.fontFamily,
    },
    outlined: {
      background: theme.palette.common.white,
    },
    label: {
      padding: '6px 0',
    },
    fullWidth: {},
  }),
  { name: 'Common_SimpleButton' },
);

export default simpleButtonStyles;
